import configClubPlaneteFitness from './config-club-planetefitness'

const config = {
  ...configClubPlaneteFitness,
  photo: {
    ...configClubPlaneteFitness.photo,
    step: "Contact",
  },
  header: {
    ...configClubPlaneteFitness.header,
    urlLogo: null
  },
  navigation: {
		reinitAuto: true,
		reinitAutoSecs: 300,
		allowChangeClub: false,
	},
  steps: {
    ...configClubPlaneteFitness.steps,
    userForm: {
      ...configClubPlaneteFitness.steps.userForm,
      optins: {
        ...configClubPlaneteFitness.steps.userForm.optins,
        acceptLegal: {
          ...configClubPlaneteFitness.steps.userForm.optins.acceptLegal,
          openInModal: true,
          moreLabel: "Lire les conditions générales",
        },
      },
    },
  },
}

export default config;
